import {
  ConsultaSeguimentoPerguntaStatusEnum,
  PassouFalhouEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import {
  AplicacoesByPergunta,
  CONSULTA_SEGUIMENTO_PERGUNTA_TO_SUB_PERGUNTA,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoTitleCase } from 'components/form'
import { MChatPerguntaEnum, MChatPerguntaOpcaoEnum } from 'graphql/types.generated'

export const HISTORICO_MCHAT_CALCULATION_STATUS = ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO

export const convertToPassouFalhou = (value: boolean | null | undefined): PassouFalhouEnum | undefined => {
  if (value === null || value === undefined) return undefined
  return value ? PassouFalhouEnum.PASSOU : PassouFalhouEnum.FALHOU
}

export const groupAplicacoesByPergunta = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): AplicacoesByPergunta =>
  aplicacoes.reduce<AplicacoesByPergunta>((acc, aplicacao) => {
    const pergunta = SUB_PERGUNTA_TO_PERGUNTA[aplicacao.pergunta]

    if (pergunta) {
      acc[pergunta] = [...acc[pergunta], aplicacao]
    }

    return acc
  }, createEmptyAplicacoesByPergunta())

const createEmptyAplicacoesByPergunta = (): AplicacoesByPergunta =>
  Object.values(MChatPerguntaEnum).reduce<AplicacoesByPergunta>(
    (acc, pergunta) => ({
      ...acc,
      [pergunta]: [],
    }),
    {} as AplicacoesByPergunta
  )

const SUB_PERGUNTA_TO_PERGUNTA = Object.entries(CONSULTA_SEGUIMENTO_PERGUNTA_TO_SUB_PERGUNTA).reduce<
  Partial<Record<MChatPerguntaEnum, MChatPerguntaEnum>>
>((acc, [pergunta, subPerguntas]) => {
  subPerguntas.forEach((subPergunta) => {
    acc[subPergunta] = pergunta as MChatPerguntaEnum
  })

  return acc
}, {})

export const splitHeaderAndPerguntas = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>,
  headerPergunta: MChatPerguntaEnum
): { header: MchatRfAplicacaoQueryModel | undefined; perguntas: MchatRfAplicacaoQueryModel[] } => {
  let header: MchatRfAplicacaoQueryModel | undefined
  const perguntas: MchatRfAplicacaoQueryModel[] = []

  aplicacoes.forEach((aplicacao) => {
    if (aplicacao.pergunta === headerPergunta) {
      header = header ?? aplicacao
    } else {
      perguntas.push(aplicacao)
    }
  })

  return { header, perguntas }
}

export const getOutroOuPergunta = (aplicacao: MchatRfAplicacaoQueryModel): string =>
  aplicacao.outros ? 'Outro:' : aplicacao.textoPergunta

export const getOutroOuResposta = (aplicacao: MchatRfAplicacaoQueryModel): string | undefined => {
  if (aplicacao.perguntaOpcao !== null && aplicacao.perguntaOpcao !== undefined)
    return PERGUNTA_OPCAO_LABEL[aplicacao.perguntaOpcao]
  if (aplicacao.outros !== null && aplicacao.outros !== undefined)
    return aplicacao.outros + ' - ' + booleanToSimNaoTitleCase(aplicacao.stPassou)
  return booleanToSimNaoTitleCase(aplicacao.stPassou)
}

const PERGUNTA_OPCAO_LABEL: Partial<Record<MChatPerguntaOpcaoEnum, string>> = {
  [MChatPerguntaOpcaoEnum.AJUDA]: 'Para conseguir ajuda',
  [MChatPerguntaOpcaoEnum.AUDICAO_ABAIXO]: 'Audição abaixo do normal',
  [MChatPerguntaOpcaoEnum.AUDICAO_NORMAL]: 'Audição na faixa normal',
  [MChatPerguntaOpcaoEnum.INTERESSE]: 'Tanto para mostrar o interesse dele/dela como para conseguir ajuda',
  [MChatPerguntaOpcaoEnum.NAO_DEFINITIVO]: 'Resultados que não tiveram conclusão ou não definitivos',
}
